import styled from "styled-components";

export const Remove = styled.div`
    position: absolute;
    width: 40px;
    height: 40px;
    line-height: 40px;
    border-radius: 20px;
    background-color: ${p => p.theme.c.blackShadow2};
    text-align: center;
    cursor: pointer;
    margin-top: 6px;
`;
